export default __webpack_public_path__ + "static/media/tree.a43de0aa.webp";